import React from 'react';
import { useTimer } from 'react-timer-hook';
import TimerStyled from './TimerStyled';

interface MyTimerProps {
  expiryTimestamp: Date,
  header?: string
  style?: any
  onComplete?: () => void
}

const MyTimer: React.FC<MyTimerProps> = ({ expiryTimestamp, style, onComplete }) => {
  const {
    seconds,
    minutes,
    hours,
    days,
    isRunning
  } = useTimer({ expiryTimestamp, onExpire: () => onComplete() });

  return <TimerStyled
    seconds={seconds}
    minutes={minutes}
    hours={hours}
    days={days}
    style={style}
  />
}
export default MyTimer